export enum CalculationMethodEnum {
  ADD_FIXED = 'ADD_FIXED',
  ADD_PERCENTAGE = 'ADD_PERCENTAGE',
}
